import { MessageContentProps } from './Types'
import { TextMessageRenderer } from './TextMessageRenderer'
import { ProcessingContent } from './ProcessingContent'
import { ProcessingSteps } from './ProcessingSteps/ProcessingSteps'
import { DesignContent } from './DesignPreview/DesignContent'
import { CaptionsContent } from './CaptionsContent/CaptionsContent'
import { UnsupportedRequestContent } from './UnsupportedRequestContent/UnsupportedRequestContent'
import { GeneratedMediaContent } from './GeneratedMediaContent/GeneratedMediaContent'
import { ImageContent } from './ImageContent/ImageContent'
import { InsufficientCreditsContent } from './InsufficientCreditsContent/InsufficientCreditsContent'
import { CreditUsageContent } from './CreditUsageContent/CreditUsageContent'

export const MessageContent = ({ content, message }: MessageContentProps) => {
  if (content.type === 'text') {
    return <TextMessageRenderer>{content.text + ''}</TextMessageRenderer>
  } else if (content.type === 'image') {
    return <ImageContent content={content} />
  } else if (content.type === 'processing') {
    return <ProcessingContent content={content} message={message} />
  } else if (content.type === 'design_content') {
    return (
      <DesignContent
        content={content.content}
        width={content.width}
        height={content.height}
        design_id={content.design_id}
      />
    )
  } else if (content.type === 'captions') {
    return <CaptionsContent content={content} />
  } else if (content.type === 'unsupported_request') {
    return <UnsupportedRequestContent content={content} />
  } else if (content.type === 'generation_steps') {
    return <ProcessingSteps steps={content.steps} />
  } else if (content.type === 'generated_image' || content.type === 'generated_video') {
    return <GeneratedMediaContent content={content} />
  } else if (content.type === 'insufficient_credits') {
    return <InsufficientCreditsContent content={content} message={message} />
  } else if (content.type === 'credit_usage') {
    return <CreditUsageContent content={content} />
  }

  return null
}
